// extracted by mini-css-extract-plugin
export default {"container":"informationContainer_container__+TWVE","information":"informationContainer_information__ndH5K"};